<template>
  <div class="ma-4">
    <v-snackbar v-model="msg" top
      >{{ text }}
      <v-btn color="pink" text @click="msg = false"> Close</v-btn></v-snackbar
    >
    <v-container>
      <v-row>
        <v-col cols="12" md="3">
          <v-card class="mx-auto pa-2" max-width="374">
            <!-- Use info dialog -->
            <v-dialog v-model="seditInfo" max-width="70%">
              <v-card>
                <v-card-title>
                  <span class="headline"> Update Info </span>
                </v-card-title>

                <v-card-text>
                  <v-form ref="form" lazy-validation>
                    <v-container>
                      <v-row>
                        <v-col cols="12" sm="12" md="6">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                              <v-text-field
                                v-model="newEmail"
                                label="Email"
                                v-on="on"
                              ></v-text-field>
                            </template>
                            <span
                              >This email will be used to login in the
                              account.</span
                            >
                          </v-tooltip>
                        </v-col>
                        <v-col cols="12" sm="12" md="6">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                              <v-text-field
                                v-model="newName"
                                label="Account Name"
                                v-on="on"
                                :readonly="!isAdmin"
                              ></v-text-field>
                            </template>
                            <span
                              >The name of the employee for this account.</span
                            >
                          </v-tooltip>
                        </v-col>
                        <v-col cols="12" sm="12" md="6">
                          <v-menu offset-y min-width="290px" max-width="290px">
                            <template v-slot:activator="{ on }">
                              <v-text-field
                                label="Date Hired"
                                v-on="on"
                                :value="newDate"
                                :readonly="!isAdmin"
                              >
                              </v-text-field>
                            </template>
                            <v-date-picker
                              v-model="newDate"
                              scrollable
                              :readonly="!isAdmin"
                            ></v-date-picker>
                          </v-menu>
                        </v-col>
                        <v-col cols="12" sm="12" md="6" v-if="Role === 'Administration'">
                          <v-select
                            v-model="newProgram"
                            label="Program"
                            :items="programs"
                            item-text="Name"
                            item-value="Name"
                            multiple
                          ></v-select>
                        </v-col>
                              <v-col cols="12" sm="12" md="6">
                                  <v-menu
                                      ref="birthMenu"
                                      v-model="birthMenu"
                                      :close-on-content-click="false"
                                      transition="scale-transition"
                                      offset-y
                                      min-width="auto"
                                  >
                                      <template v-slot:activator="{ on, attrs }">
                                          <v-text-field
                                              v-model="birthDate"
                                              label="Birthday"
                                              readonly
                                              v-bind="attrs"
                                              v-on="on"
                                          ></v-text-field>
                                      </template>
                                      <v-date-picker
                                          v-model="birthDate"
                                          :active-picker.sync="activePicker"
                                          :max="(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)"
                                          min="1950-01-01"
                                          @change="$refs.birthMenu.save(birthDate)"
                                      ></v-date-picker>
                                  </v-menu>
                              </v-col>
                        <v-col cols="12" sm="12" md="6">
                          <v-text-field
                            v-model="newPhoneNumber"
                            label="Phone Number"
                          ></v-text-field>
                        </v-col>
                        <!-- <v-col cols="12" sm="12" md="6">
                          <v-text-field
                            v-model="newPhoneCarrier"
                            label="Phone Carrier"
                          ></v-text-field>
                        </v-col> -->
                        <v-col cols="12" sm="12">
                          <v-text-field
                            v-model="newAddress"
                            label="Address"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="12" md="6">
                          <v-text-field
                            v-model="newCity"
                            label="City"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="12" md="6">
                          <v-select
                            v-model="newState"
                            label="State"
                            :items="states"
                          ></v-select>
                          <!--
                          <v-text-field
                            v-model="newState"
                            label="State"
                          ></v-text-field>-->
                        </v-col>
                        <v-col cols="12" sm="12" md="6">
                          <v-text-field
                            v-model="newZip"
                            label="Zip"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="12" md="6">
                          <v-menu
                            ref="anniversaryMenu"
                            v-model="anniversaryMenu"
                            :close-on-content-click="false"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                v-model="anniversaryDate"
                                label="Anniversary"
                                v-bind="attrs"
                                v-on="on"
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              v-model="anniversaryDate"
                              :active-picker.sync="activePicker"
                              :max="(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)"
                              min="1950-01-01"
                              @change="$refs.anniversaryMenu.save(anniversaryDate)"
                            ></v-date-picker>
                          </v-menu>
                        </v-col>

                        <!-- <v-col cols="12" sm="12" md="6">
                          <v-select label="Security Question"></v-select>
                        </v-col> -->

                        <!-- <v-col cols="12" md="6"></v-col> -->

                        <v-col cols="12" md="6">

                          <v-btn
                              small
                              @click="clearSignature"
                              v-if="isAdmin && userSignatureImgSrc"
                              class="error"
                          >
                              Clear Signature
                          </v-btn>

                          <v-btn small @click="openSignaturePad('signature')" v-if='userSignatureImgSrc == null'>
                          Add Signature
                          </v-btn>

                          <SignaturePad
                          :showSignaturePad="showSignaturePad"
                          @close="showSignaturePad = false"
                          @signatureData="handleSignatureData"
                          />


                          <!-- Image for Signature -->

                          </v-col>

                          <v-col cols="12" md="6">
                          <img :src="userSignatureImgSrc" alt="User Signature" v-if="userSignatureImgSrc != null" height="125"/>

                          </v-col>

                          <v-col cols="12" md="6">
                          <SignaturePad
                              :showSignaturePad="showInitialsPad"
                              @close="showInitialsPad = false"
                              @signatureData="handleInitialsData"

                              />

                              <v-btn
                                  small
                                  @click="clearInitials"
                                  v-if="isAdmin && userInitialsImgSrc"
                                  class="error"
                              >
                                  Clear Initials
                              </v-btn>

                              <v-btn small @click="openInitialsPad('initials')" v-if="userInitialsImgSrc == null">
                              Add Initials
                              </v-btn>

                          </v-col>

                          <v-col cols="12" md="6">
                          <img :src="userInitialsImgSrc" alt="User Initials" v-if="userInitialsImgSrc != null" height="125"/>

                          </v-col>
                      </v-row>
                    </v-container>
                  </v-form>
                </v-card-text>

                <v-card-actions>
                  <v-btn class="primary white--text" text @click="updateInfo()"
                    >Update</v-btn
                  >
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" text @click="close"
                    >Cancel</v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-dialog>
            <!-- use change passwod dialog- -->
            <v-dialog v-model="passdialog" max-width="50%">
              <v-card>
                <v-card-title>
                  <span class="headline">Change Password</span>
                </v-card-title>

                <v-card-text>
                  <v-form ref="form" lazy-validation>
                    <v-container>
                      <v-row>
                        <v-col cols="12" sm="12" md="12">
                          <v-text-field
                            v-model="Pass"
                            type="password"
                            label="Password"
                            :rules="requiredField"
                          ></v-text-field>
                          
                          <!-- Password strength indicator -->
                          <div v-if="Pass" class="mt-2">
                            <v-progress-linear
                              :value="passwordStrengthScore * 20"
                              :color="passwordStrengthColor"
                              height="8"
                              rounded
                            ></v-progress-linear>
                            <div class="text-caption mt-1" :class="`${passwordStrengthColor}--text`">
                              {{ passwordStrengthMessage }}
                            </div>
                          </div>
                          
                          <!-- Password requirements -->
                          <v-card v-if="Pass" class="mt-2 pa-2" outlined>
                            <div class="text-caption font-weight-bold mb-1">Password Requirements:</div>
                            <div class="text-caption" :class="passwordRequirements.length ? 'green--text' : 'red--text'">
                              ✓ At least 8 characters
                            </div>
                            <div class="text-caption" :class="passwordRequirements.uppercase ? 'green--text' : 'red--text'">
                              ✓ At least one uppercase letter (A-Z)
                            </div>
                            <div class="text-caption" :class="passwordRequirements.lowercase ? 'green--text' : 'red--text'">
                              ✓ At least one lowercase letter (a-z)
                            </div>
                            <div class="text-caption" :class="passwordRequirements.numbers ? 'green--text' : 'red--text'">
                              ✓ At least one number (0-9)
                            </div>
                            <div class="text-caption" :class="passwordRequirements.special ? 'green--text' : 'red--text'">
                              ✓ At least one special character (!@#$%^&*)
                            </div>
                          </v-card>
                        </v-col>

                        <v-col cols="12" sm="12" md="12">
                          <v-text-field
                            v-model="RePass"
                            type="password"
                            label="Retype Password"
                            :rules="requiredField"
                          ></v-text-field>
                        </v-col>
                        
                        <!-- Password validation message -->
                        <v-col cols="12" v-if="passwordMatchMessage">
                          <v-alert
                            type="error"
                            dense
                            dismissible
                          >
                            {{ passwordMatchMessage }}
                          </v-alert>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-form>
                </v-card-text>

                <v-card-actions>
                  <v-btn color="blue darken-1" text @click="updatePassword()"
                    >Update</v-btn
                  >
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" text @click="close"
                    >Cancel</v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-dialog>
            <!-- user timezone dialog -->
            <v-dialog v-model="tzDialog" max-width="500px">
              <v-card>
                <v-card-title>
                  Update Timezone
                </v-card-title>
                <v-card-text>
                  <!-- <v-select
                   v-model="userTimezone"
                    item-text="`${data.item.name}, ${data.item.group}`"
                    :items="getTimezones"
                    label="Select your timezone"
                  >

                    <template slot="selection" slot-scope="data">
                  {{ data.item.name}}, {{data.item.group}}
                </template>

                  </v-select> -->

                  <v-select
                    :items="getTimezones"
                    item-text="offset"
                    item-value="tzCode"
                    v-model="userTimezone"
                    label="Select your timezone"
                  >
                    <template slot="selection" slot-scope="data">
                      (UTC {{ data.item.offset }}) {{ data.item.tzCode }}
                    </template>
                    <template slot="item" slot-scope="data">
                      (UTC {{ data.item.offset }}) {{ data.item.tzCode }}
                    </template>
                  </v-select>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" @click="updateTimezoneHandler(true)">
                    Set Default Timezone
                  </v-btn>
                  <v-btn color="primary" text @click="updateTimezoneHandler()">
                    Update
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>

            <v-responsive d-flex justify-center class="mt-5 mb-5">
              <v-layout d-flex justify-center>
                <v-dialog v-model="chgimg" max-width="40%">
                  <v-card>
                    <v-card-title>
                      <span class="headline">Change Picture</span>
                    </v-card-title>
                    <form enctype="multipart/form-data">
                      <v-file-input
                        class="pa-4"
                        label="Upload image"
                        filled
                        prepend-icon="mdi-camera"
                        accept="image/*"
                        @change="imgSelected"
                      ></v-file-input>
                      <v-card-actions>
                        <v-btn color="blue darken-1" text @click="saveImg()"
                          >Update Profile Picture</v-btn
                        >
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" text @click="close"
                          >Cancel</v-btn
                        >
                      </v-card-actions>
                    </form>
                  </v-card>
                </v-dialog>

                <v-hover>
                  <template v-slot:default="{ hover }">
                    <v-card width="200px" class="ma-auto">
                      <v-img
                        :lazy-src="profileimg"
                        height="200"
                        max-width="200"
                        :src="profileimg"
                      ></v-img>
                      <v-fade-transition>
                        <v-overlay v-if="hover" absolute color="#036358">
                          <v-btn @click="chgImg()">Change Picture</v-btn>
                        </v-overlay>
                      </v-fade-transition>
                    </v-card>
                  </template>
                </v-hover>
              </v-layout>
            </v-responsive>
            <v-layout d-block text-center class="mt-2 mb-1">
              <v-card outlined color="white">
                <v-card-title>
                  <v-spacer></v-spacer>
                  <span class="ml-7">{{ user.Name }}</span>
                  <v-spacer></v-spacer>
                  <v-menu
                    bottom
                    origin="center center"
                    transition="scale-transition"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn v-bind="attrs" v-on="on" color="primary" fab small>
                        <v-icon>mdi-dots-vertical</v-icon>
                      </v-btn>
                    </template>
                    <v-list>
                      <v-list-item>
                        <v-list-item-title>
                          <a @click="editInfo()">Update Info</a>
                        </v-list-item-title>
                      </v-list-item>
                      <v-list-item>
                        <v-list-item-title>
                          <a @click="editPassword()">Change Password</a>
                        </v-list-item-title>
                      </v-list-item>
                      <v-list-item>
                        <v-list-item-title>
                          <a @click="editTimezone()">Change Timezone</a>
                        </v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </v-card-title>
              </v-card>
            </v-layout>

            <v-divider class="mx-4"></v-divider>
            <v-card-text>Phone Number</v-card-text>
            <v-card-title class="mt-n2 mb-2">
              <div class="subtitle-1">
                {{ user.PhoneNumber }}
              </div>
            </v-card-title>
            <v-card-text>Email</v-card-text>
            <v-card-title class="mt-n2 mb-2">
              <div class="subtitle-1">
                {{ user.Email }}
              </div>
            </v-card-title>
            <v-card-text>Status</v-card-text>
            <v-card-title class="mt-n2 mb-2">
              <div class="subtitle-1">
                {{ user.Status }}
              </div>
            </v-card-title>
            <v-card-text>User Role</v-card-text>
            <v-card-title class="mt-n2 mb-2">
              <div class="subtitle-1">
                {{ user.Role }}
              </div>
            </v-card-title>
            <v-card-text>Timezone</v-card-text>
            <v-card-title class="mt-n2">
              <div class="subtitle-1">
                {{ timezone }}
              </div>
            </v-card-title>
          </v-card>
        </v-col>
        <v-col cols="12" md="9">
          <v-row>
            <v-col cols="12" md="12">
              <v-card class="pa-2 ">
                <v-card-text>
                  <p class="headline text--primary">
                    User Information
                  </p>
                  <v-divider class="mx-1"></v-divider>
                </v-card-text>
                <v-row class="mt-5">
                  <v-col cols="12" sm="12" md="4" class="col-padding col-mt">
                    <v-card-text>
                      <span class="caption font-weight-light">ADDRESS</span>
                      <p class="subtitle-1">{{ user.Address }}</p>
                    </v-card-text>
                  </v-col>
                  <v-col cols="12" sm="12" md="4" class="col-padding col-mt">
                    <v-card-text>
                      <span class="caption font-weight-light"
                        >PHONE PROVIDER</span
                      >
                      <p class="subtitle-1">{{ user.PhoneCarrier }}</p>
                    </v-card-text>
                  </v-col>
                </v-row>
                <v-row class="mt-5">
                  <v-col cols="12" sm="12" md="4" class="col-padding col-mt">
                    <v-card-text>
                      <span class="caption font-weight-light text-uppercase"
                        >Program</span
                      >
                      <p class="subtitle-1">
                        <span v-for="program in user.Program" :key="program._id">
                          {{ program }},
                        </span>
                      </p>
                    </v-card-text>
                  </v-col>
                  <v-col cols="12" sm="12" md="4" class="col-padding col-mt">
                    <v-card-text>
                      <span class="caption font-weight-light text-uppercase">Position</span>
                      <p class="subtitle-1">{{ user.Position }}</p>
                    </v-card-text>
                  </v-col>
                </v-row>
                <v-row class="mt-5">
                  <v-col cols="12" sm="12" md="4" class="col-padding col-mt">
                    <v-card-text>
                      <span class="caption font-weight-light text-uppercase"
                        >Birth Date</span
                      >
                      <p class="subtitle-1">{{ user.BirthDate }}</p>
                    </v-card-text>
                  </v-col>
                  <v-col cols="12" sm="12" md="4" class="col-padding col-mt">
                    <v-card-text>
                      <span class="caption font-weight-light text-uppercase"
                        >Anniversary</span
                      >
                      <p class="subtitle-1">{{ user.AnniversaryDate }}</p>
                    </v-card-text>
                  </v-col>
                  <v-col cols="12" sm="12" md="4" class="col-padding col-mt">
                    <v-card-text>
                      <span class="caption font-weight-light">HIRE DATE</span>
                      <p class="subtitle-1">{{ user.Date }}</p>
                    </v-card-text>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="12">
              <v-card class="mx-auto">
                <v-tabs v-model="tab" class="mt-3">
                  <v-tabs-slider></v-tabs-slider>
                  <v-tab v-for="t in tabs" :key="t" :href="`#tab-${t}`">
                    {{ t }}
                  </v-tab>
                  <v-tab-item :value="'tab-User Notification'" class="pa-5">
                    <template>
                      <v-card>
                        <v-toolbar flat>
                          <v-toolbar-title>Set Notifications</v-toolbar-title>
                        </v-toolbar>
                        <v-tabs vertical class="my-tabs">
                          <v-tab>
                            <v-icon>
                              mdi-account
                            </v-icon>
                            Default
                          </v-tab>
                          <v-tab>
                            <v-icon>
                              mdi-email
                            </v-icon>
                            Email
                          </v-tab>
                          <v-tab>
                            <v-icon>
                              mdi-cellphone
                            </v-icon>
                            Text
                          </v-tab>
                          <v-tab>
                            <v-icon>
                              mdi-bell
                            </v-icon>
                            Push
                          </v-tab>
                          <v-tab-item>
                            <v-card-text>
                              <v-row>
                                <v-col>
                                  <div class="font-weight-black">
                                    Staff Notification
                                  </div>
                                  <div>
                                    <v-checkbox
                                      v-model="notifications.employees.create"
                                      hide-details
                                      label="Create staff"
                                    ></v-checkbox>
                                    <v-checkbox
                                      v-model="notifications.employees.update"
                                      hide-details
                                      label="Update staff"
                                    ></v-checkbox>
                                    <v-checkbox
                                      v-model="notifications.employees.delete"
                                      hide-details
                                      label="Delete staff"
                                    ></v-checkbox>
                                  </div>
                                </v-col>
                                <v-col>
                                  <div class="font-weight-black">
                                    Incident Notification
                                  </div>
                                  <div>
                                    <v-checkbox
                                      v-model="notifications.incidents.create"
                                      hide-details
                                      label="Create incident"
                                    ></v-checkbox>
                                    <v-checkbox
                                      v-model="notifications.incidents.update"
                                      hide-details
                                      label="Update incident"
                                    ></v-checkbox>
                                    <v-checkbox
                                      v-model="notifications.incidents.delete"
                                      hide-details
                                      label="Delete incident"
                                    ></v-checkbox>
                                  </div>
                                </v-col>
                                <v-col>
                                  <div class="font-weight-black">
                                    User Notification
                                  </div>
                                  <div>
                                    <v-checkbox
                                      v-model="notifications.users.create"
                                      hide-details
                                      label="Create user"
                                    ></v-checkbox>
                                    <v-checkbox
                                      v-model="notifications.users.update"
                                      hide-details
                                      label="Update user"
                                    ></v-checkbox>
                                    <v-checkbox
                                      v-model="notifications.users.delete"
                                      hide-details
                                      label="Delete user"
                                    ></v-checkbox>
                                  </div>
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col>
                                  <div class="font-weight-black">
                                    Shift Notification
                                  </div>
                                  <div>
                                    <v-checkbox
                                      v-model="notifications.shifts.create"
                                      hide-details
                                      label="Create shift"
                                    ></v-checkbox>
                                    <v-checkbox
                                      v-model="notifications.shifts.update"
                                      hide-details
                                      label="Update shift"
                                    ></v-checkbox>
                                    <v-checkbox
                                      v-model="notifications.shifts.delete"
                                      hide-details
                                      label="Delete shift"
                                    ></v-checkbox>
                                  </div>
                                </v-col>
                                <v-col>
                                  <div class="font-weight-black">
                                    Calendar Notification
                                  </div>
                                  <div>
                                    <v-checkbox
                                      v-model="notifications.calendar.create"
                                      hide-details
                                      label="Create event"
                                    ></v-checkbox>
                                    <v-checkbox
                                      v-model="notifications.calendar.update"
                                      hide-details
                                      label="Update event"
                                    ></v-checkbox>
                                    <v-checkbox
                                      v-model="notifications.calendar.delete"
                                      hide-details
                                      label="Delete event"
                                    ></v-checkbox>
                                  </div>
                                </v-col>
                                <v-col>
                                  <div class="font-weight-black">
                                    Task Notification
                                  </div>
                                  <div>
                                    <v-checkbox
                                      v-model="notifications.task.create"
                                      hide-details
                                      label="Create task"
                                    ></v-checkbox>
                                    <v-checkbox
                                      v-model="notifications.task.update"
                                      hide-details
                                      label="Update task"
                                    ></v-checkbox>
                                    <v-checkbox
                                      v-model="notifications.task.delete"
                                      hide-details
                                      label="Delete task"
                                    ></v-checkbox>
                                  </div>
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col>
                                  <div class="font-weight-black">
                                    Maintenance Request Notification
                                  </div>
                                  <div>
                                    <v-checkbox
                                      v-model="notifications.maintenance.create"
                                      hide-details
                                      label="Create maintenance request"
                                    ></v-checkbox>
                                    <v-checkbox
                                      v-model="notifications.maintenance.update"
                                      hide-details
                                      label="Update maintenance request"
                                    ></v-checkbox>
                                  </div>
                                </v-col>
                                 <v-col>
                                  <div class="font-weight-black">
                                    Time Off Request Notification
                                  </div>
                                  <div>
                                    <v-checkbox
                                      v-model="notifications.timeoff.create"
                                      hide-details
                                      label="Create time off request"
                                    ></v-checkbox>
                                    <v-checkbox
                                      v-model="notifications.timeoff.update"
                                      hide-details
                                      label="Update time off request"
                                    ></v-checkbox>
                                    <v-checkbox
                                      v-model="notifications.timeoff.delete"
                                      hide-details
                                      label="Delete time off request"
                                    ></v-checkbox>
                                  </div>
                                </v-col>
                                <v-col>
                                  <div class="font-weight-black">
                                    Vehicle Inspection Notification
                                  </div>
                                  <div>
                                    <v-checkbox
                                      v-model="notifications.vehicleInspection.update"
                                      hide-details
                                      label="Notes update"
                                    ></v-checkbox>
                                  </div>
                                </v-col>
                             </v-row>
                              <v-row>
                                <v-col>
                                  <div class="font-weight-black">
                                    Training Notification
                                  </div>
                                  <div>
                                    <v-checkbox
                                      v-model="notifications.training.create"
                                      hide-details
                                      label="Create training request"
                                    ></v-checkbox>
                                    <v-checkbox
                                      v-model="notifications.training.update"
                                      hide-details
                                      label="Update training request"
                                    ></v-checkbox>
                                    <v-checkbox
                                      v-model="notifications.training.delete"
                                      hide-details
                                      label="Delete training request"
                                    ></v-checkbox>
                                  </div>
                                </v-col>
                              </v-row>

                            </v-card-text>
                            <v-card-text>
                              <v-row
                                align="center"
                                justify="end"
                                class="mx-2 my-2"
                              >
                                <v-card-actions>
                                  <v-btn
                                    color="primary"
                                    @click="saveNotifSettings()"
                                    >Update</v-btn
                                  >
                                </v-card-actions>
                              </v-row>
                            </v-card-text>
                          </v-tab-item>

                          <v-tab-item>
                            <v-card-text>
                              <v-row>
                                <v-col>
                                  <div class="font-weight-black">
                                    Staff Notification
                                  </div>
                                  <div>
                                    <v-checkbox
                                      v-model="notifications.employees.createEmail"
                                      hide-details
                                      label="Create staff"
                                    ></v-checkbox>
                                    <v-checkbox
                                      v-model="notifications.employees.updateEmail"
                                      hide-details
                                      label="Update staff"
                                    ></v-checkbox>
                                    <v-checkbox
                                      v-model="notifications.employees.deleteEmail"
                                      hide-details
                                      label="Delete staff"
                                    ></v-checkbox>
                                  </div>
                                </v-col>
                                <v-col>
                                  <div class="font-weight-black">
                                    Incident Notification
                                  </div>
                                  <div>
                                    <v-checkbox
                                      v-model="notifications.incidents.createEmail"
                                      hide-details
                                      label="Create incident"
                                    ></v-checkbox>
                                    <v-checkbox
                                      v-model="notifications.incidents.updateEmail"
                                      hide-details
                                      label="Update incident"
                                    ></v-checkbox>
                                    <v-checkbox
                                      v-model="notifications.incidents.deleteEmail"
                                      hide-details
                                      label="Delete incident"
                                    ></v-checkbox>
                                  </div>
                                </v-col>
                                <v-col>
                                  <div class="font-weight-black">
                                    User Notification
                                  </div>
                                  <div>
                                    <v-checkbox
                                      v-model="notifications.users.createEmail"
                                      hide-details
                                      label="Create user"
                                    ></v-checkbox>
                                    <v-checkbox
                                      v-model="notifications.users.updateEmail"
                                      hide-details
                                      label="Update user"
                                    ></v-checkbox>
                                    <v-checkbox
                                      v-model="notifications.users.deleteEmail"
                                      hide-details
                                      label="Delete user"
                                    ></v-checkbox>
                                  </div>
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col>
                                  <div class="font-weight-black">
                                    Shift Notification
                                  </div>
                                  <div>
                                    <v-checkbox
                                      v-model="notifications.shifts.createEmail"
                                      hide-details
                                      label="Create shift"
                                    ></v-checkbox>
                                    <v-checkbox
                                      v-model="notifications.shifts.updateEmail"
                                      hide-details
                                      label="Update shift"
                                    ></v-checkbox>
                                    <v-checkbox
                                      v-model="notifications.shifts.deleteEmail"
                                      hide-details
                                      label="Delete shift"
                                    ></v-checkbox>
                                  </div>
                                </v-col>
                                  <v-col>
                                  <div class="font-weight-black">
                                    Incoming Shift Notification
                                  </div>
                                  <div>
                                    <v-select
                                      :items="['15 minutes','30 minutes', '45 minutes','1 Hour', '2 Hours', '3 Hours', '4 Hours', '5 Hours', '6 Hours','7 Hours','8 Hours','9 Hours','10 Hours','11 Hours','12 Hours',
                                                '13 Hours', '14 Hours', '15 Hours', '16 Hours', '17 Hours', '18 Hours', '19 Hours',
                                                '20 Hours', '21 Hours', '22 Hours', '23 Hours', '24 Hours' ]"
                                      variant="solo-filled"
                                      multiple
                                      v-model="selectedHourForShiftReminder"
                                    ></v-select>
                                  </div>
                                </v-col>
                                <v-col>
                                  <div class="font-weight-black">
                                    Calendar Notification
                                  </div>
                                  <div>
                                    <v-checkbox
                                      v-model="notifications.calendar.createEmail"
                                      hide-details
                                      label="Create event"
                                    ></v-checkbox>
                                    <v-checkbox
                                      v-model="notifications.calendar.updateEmail"
                                      hide-details
                                      label="Update event"
                                    ></v-checkbox>
                                    <v-checkbox
                                      v-model="notifications.calendar.deleteEmail"
                                      hide-details
                                      label="Delete event"
                                    ></v-checkbox>
                                  </div>
                                </v-col>
                                <v-col>
                                  <div class="font-weight-black">
                                    Task Notification
                                  </div>
                                  <div>
                                    <v-checkbox
                                      v-model="notifications.task.createEmail"
                                      hide-details
                                      label="Create task"
                                    ></v-checkbox>
                                    <v-checkbox
                                      v-model="notifications.task.updateEmail"
                                      hide-details
                                      label="Update task"
                                    ></v-checkbox>
                                    <v-checkbox
                                      v-model="notifications.task.deleteEmail"
                                      hide-details
                                      label="Delete task"
                                    ></v-checkbox>
                                  </div>
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col>
                                  <div class="font-weight-black">
                                    Maintenance Request Notification
                                  </div>
                                  <div>
                                    <v-checkbox
                                      v-model="notifications.maintenance.createEmail"
                                      hide-details
                                      label="Create maintenance request"
                                    ></v-checkbox>
                                    <v-checkbox
                                      v-model="notifications.maintenance.updateEmail"
                                      hide-details
                                      label="Update maintenance request"
                                    ></v-checkbox>
                                  </div>
                                </v-col>
                                <v-col>
                                  <div class="font-weight-black">
                                    Time Off Request Notification
                                  </div>
                                  <div>
                                    <v-checkbox
                                      v-model="notifications.timeoff.createEmail"
                                      hide-details
                                      label="Create time off request"
                                    ></v-checkbox>
                                    <v-checkbox
                                      v-model="notifications.timeoff.updateEmail"
                                      hide-details
                                      label="Update time off request"
                                    ></v-checkbox>
                                    <v-checkbox
                                      v-model="notifications.timeoff.deleteEmail"
                                      hide-details
                                      label="Delete time off request"
                                    ></v-checkbox>
                                  </div>
                                </v-col>
                                <v-col>
                                  <div class="font-weight-black">
                                    Vehicle Inspection Notification
                                  </div>
                                  <div>
                                    <v-checkbox
                                      v-model="notifications.vehicleInspection.updateEmail"
                                      hide-details
                                      label="Notes update"
                                    ></v-checkbox>
                                  </div>
                                </v-col>
                             </v-row>
                              <v-row>
                                <v-col>
                                  <div class="font-weight-black">
                                    Training Notification
                                  </div>
                                  <div>
                                    <v-checkbox
                                      v-model="notifications.training.createEmail"
                                      hide-details
                                      label="Create training request"
                                    ></v-checkbox>
                                    <v-checkbox
                                      v-model="notifications.training.updateEmail"
                                      hide-details
                                      label="Update training request"
                                    ></v-checkbox>
                                    <v-checkbox
                                      v-model="notifications.training.deleteEmail"
                                      hide-details
                                      label="Delete training request"
                                    ></v-checkbox>
                                  </div>
                                </v-col>
                                <v-col>
                                  <div class="font-weight-black">
                                    Incoming Shift Notification
                                  </div>
                                  <div>
                                    <v-select
                                      :items="['15 minutes','30 minutes', '45 minutes','1 Hour', '2 Hours', '3 Hours', '4 Hours', '5 Hours', '6 Hours','7 Hours','8 Hours','9 Hours','10 Hours','11 Hours','12 Hours',
                                                '13 Hours', '14 Hours', '15 Hours', '16 Hours', '17 Hours', '18 Hours', '19 Hours',
                                                '20 Hours', '21 Hours', '22 Hours', '23 Hours', '24 Hours' ]"
                                      variant="solo-filled"
                                      multiple
                                      v-model="selectedHourForShiftReminder"
                                    ></v-select>
                                  </div>
                                </v-col>
                                <v-col>

                                </v-col>
                             </v-row>
                            </v-card-text>
                            <v-card-text>
                              <v-row
                                align="center"
                                justify="end"
                                class="mx-2 my-2"
                              >
                                <v-card-actions>
                                  <v-btn
                                    color="primary"
                                    @click="saveNotifSettings()"
                                    >Update</v-btn
                                  >
                                </v-card-actions>
                              </v-row>
                            </v-card-text>
                          </v-tab-item>
                          <v-tab-item>
                            <v-card-text>
                              <v-row>
                                <v-col>
                                  <div class="font-weight-black">
                                    Staff Notification
                                  </div>
                                  <div>
                                    <v-checkbox
                                      v-model="notifications.employees.createText"
                                      hide-details
                                      label="Create staff"
                                    ></v-checkbox>
                                    <v-checkbox
                                      v-model="notifications.employees.updateText"
                                      hide-details
                                      label="Update staff"
                                    ></v-checkbox>
                                    <v-checkbox
                                      v-model="notifications.employees.deleteText"
                                      hide-details
                                      label="Delete staff"
                                    ></v-checkbox>
                                  </div>
                                </v-col>
                                <v-col>
                                  <div class="font-weight-black">
                                    Incident Notification
                                  </div>
                                  <div>
                                    <v-checkbox
                                      v-model="notifications.incidents.createText"
                                      hide-details
                                      label="Create incident"
                                    ></v-checkbox>
                                    <v-checkbox
                                      v-model="notifications.incidents.updateText"
                                      hide-details
                                      label="Update incident"
                                    ></v-checkbox>
                                    <v-checkbox
                                      v-model="notifications.incidents.deleteText"
                                      hide-details
                                      label="Delete incident"
                                    ></v-checkbox>
                                  </div>
                                </v-col>
                                <v-col>
                                  <div class="font-weight-black">
                                    User Notification
                                  </div>
                                  <div>
                                    <v-checkbox
                                      v-model="notifications.users.createText"
                                      hide-details
                                      label="Create user"
                                    ></v-checkbox>
                                    <v-checkbox
                                      v-model="notifications.users.updateText"
                                      hide-details
                                      label="Update user"
                                    ></v-checkbox>
                                    <v-checkbox
                                      v-model="notifications.users.deleteText"
                                      hide-details
                                      label="Delete user"
                                    ></v-checkbox>
                                  </div>
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col>
                                  <div class="font-weight-black">
                                    Shift Notification
                                  </div>
                                  <div>
                                    <v-checkbox
                                      v-model="notifications.shifts.createText"
                                      hide-details
                                      label="Create shift"
                                    ></v-checkbox>
                                    <v-checkbox
                                      v-model="notifications.shifts.updateText"
                                      hide-details
                                      label="Update shift"
                                    ></v-checkbox>
                                    <v-checkbox
                                      v-model="notifications.shifts.deleteText"
                                      hide-details
                                      label="Delete shift"
                                    ></v-checkbox>
                                  </div>
                                </v-col>
                                <v-col>
                                  <div class="font-weight-black">
                                    Calendar Notification
                                  </div>
                                  <div>
                                    <v-checkbox
                                      v-model="notifications.calendar.createText"
                                      hide-details
                                      label="Create event"
                                    ></v-checkbox>
                                    <v-checkbox
                                      v-model="notifications.calendar.updateText"
                                      hide-details
                                      label="Update event"
                                    ></v-checkbox>
                                    <v-checkbox
                                      v-model="notifications.calendar.deleteText"
                                      hide-details
                                      label="Delete event"
                                    ></v-checkbox>
                                  </div>
                                </v-col>
                                <v-col>
                                  <div class="font-weight-black">
                                    Task Notification
                                  </div>
                                  <div>
                                    <v-checkbox
                                      v-model="notifications.task.createText"
                                      hide-details
                                      label="Create task"
                                    ></v-checkbox>
                                    <v-checkbox
                                      v-model="notifications.task.updateText"
                                      hide-details
                                      label="Update task"
                                    ></v-checkbox>
                                    <v-checkbox
                                      v-model="notifications.task.deleteText"
                                      hide-details
                                      label="Delete task"
                                    ></v-checkbox>
                                  </div>
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col>
                                  <div class="font-weight-black">
                                    Maintenance Request Notification
                                  </div>
                                  <div>
                                    <v-checkbox
                                      v-model="notifications.maintenance.createText"
                                      hide-details
                                      label="Create maintenance request"
                                    ></v-checkbox>
                                    <v-checkbox
                                      v-model="notifications.maintenance.updateText"
                                      hide-details
                                      label="Update maintenance request"
                                    ></v-checkbox>
                                  </div>
                                </v-col>
                                <v-col>
                                  <div class="font-weight-black">
                                    Time Off Request Notification
                                  </div>
                                  <div>
                                    <v-checkbox
                                      v-model="notifications.timeoff.createText"
                                      hide-details
                                      label="Create time off request"
                                    ></v-checkbox>
                                    <v-checkbox
                                      v-model="notifications.timeoff.updateText"
                                      hide-details
                                      label="Update maintenance request"
                                    ></v-checkbox>
                                    <v-checkbox
                                      v-model="notifications.timeoff.deleteText"
                                      hide-details
                                      label="Delete maintenance request"
                                    ></v-checkbox>
                                  </div>
                                </v-col>
                                <v-col>
                                  <div class="font-weight-black">
                                    Vehicle Inspection Notification
                                  </div>
                                  <div>
                                    <v-checkbox
                                      v-model="notifications.vehicleInspection.updateText"
                                      hide-details
                                      label="Notes update"
                                    ></v-checkbox>
                                  </div>
                                </v-col>
                             </v-row>

                              <v-row>
                                <v-col>
                                  <div class="font-weight-black">
                                    Training Notification
                                  </div>
                                  <div>
                                    <v-checkbox
                                      v-model="notifications.training.createText"
                                      hide-details
                                      label="Create training request"
                                    ></v-checkbox>
                                    <v-checkbox
                                      v-model="notifications.training.updateText"
                                      hide-details
                                      label="Update training request"
                                    ></v-checkbox>
                                    <v-checkbox
                                      v-model="notifications.training.deleteText"
                                      hide-details
                                      label="Delete training request"
                                    ></v-checkbox>
                                  </div>
                                </v-col>
                              </v-row>
                            </v-card-text>
                            <v-card-text>
                              <v-row
                                align="center"
                                justify="end"
                                class="mx-2 my-2"
                              >
                                <v-card-actions>
                                  <v-btn
                                    color="primary"
                                    @click="saveNotifSettings()"
                                    >Update</v-btn
                                  >
                                </v-card-actions>
                              </v-row>
                            </v-card-text>
                          </v-tab-item>
                          <v-tab-item>
                            <v-card-text>
                              <v-row>
                                <v-col>
                                  <div class="font-weight-black">
                                    Push Notification Settings
                                  </div>
                                  <div>
                                    <v-checkbox
                                      v-model="pushNotifications.enabled"
                                      hide-details
                                      label="Enable push notifications"
                                      @change="handlePushNotificationsToggle"
                                    ></v-checkbox>
                                    <v-checkbox
                                      v-model="pushNotifications.sound"
                                      hide-details
                                      label="Sound"
                                      :disabled="!pushNotifications.enabled"
                                    ></v-checkbox>
                                    <v-checkbox
                                      v-model="pushNotifications.vibration"
                                      hide-details
                                      label="Vibration"
                                      :disabled="!pushNotifications.enabled"
                                    ></v-checkbox>
                                    <v-checkbox
                                      v-model="pushNotifications.preview"
                                      hide-details
                                      label="Show message preview"
                                      :disabled="!pushNotifications.enabled"
                                    ></v-checkbox>
                                  </div>
                                  <v-btn
                                    v-if="pushNotifications.enabled"
                                    color="primary"
                                    small
                                    class="mt-2"
                                    @click="testPushNotification"
                                  >
                                    <v-icon left>mdi-bell</v-icon>
                                    Test Notification
                                  </v-btn>
                                  <div v-if="pushNotifications.status" class="mt-2">
                                    <v-alert
                                      :type="pushNotifications.status.type"
                                      dense
                                      text
                                    >
                                      {{ pushNotifications.status.message }}
                                    </v-alert>
                                  </div>
                                </v-col>
                              </v-row>
                            </v-card-text>
                          </v-tab-item>
                        </v-tabs>
                      </v-card>
                    </template>
                  </v-tab-item>

                  <v-tab-item :value="'tab-Client Notification'" class="pa-5">
                    <template>
                      <v-card>
                        <v-toolbar flat>
                          <v-toolbar-title>Set Notifications</v-toolbar-title>
                        </v-toolbar>
                        <v-tabs vertical class="my-tabs">
                          <v-tab>
                            <v-icon>
                              mdi-account
                            </v-icon>
                            Default
                          </v-tab>
                          <v-tab>
                            <v-icon>
                              mdi-email
                            </v-icon>
                            Email
                          </v-tab>
                          <v-tab>
                            <v-icon>
                              mdi-cellphone
                            </v-icon>
                            Text
                          </v-tab>
                          <v-tab-item>
                            <v-card-text>
                              <v-row>
                                <v-col>
                                  <div class="font-weight-black">
                                    MAR Notification
                                  </div>
                                  <div>
                                    <v-checkbox
                                      v-model="notifications.mar.create"
                                      hide-details
                                      label="Create MAR"
                                    ></v-checkbox>
                                    <v-checkbox
                                      v-model="notifications.mar.update"
                                      hide-details
                                      label="Update MAR"
                                    ></v-checkbox>
                                    <v-checkbox
                                      v-model="notifications.mar.delete"
                                      hide-details
                                      label="Delete MAR"
                                    ></v-checkbox>
                                  </div>
                                </v-col>
                                <v-col>
                                  <div class="font-weight-black">
                                    ADL Notification
                                  </div>
                                  <div>
                                    <v-checkbox
                                      v-model="notifications.adl.create"
                                      hide-details
                                      label="Create ADL"
                                    ></v-checkbox>
                                    <v-checkbox
                                      v-model="notifications.adl.update"
                                      hide-details
                                      label="Update ADL"
                                    ></v-checkbox>
                                    <v-checkbox
                                      v-model="notifications.adl.delete"
                                      hide-details
                                      label="Delete ADL"
                                    ></v-checkbox>
                                  </div>
                                </v-col>
                                <v-col>
                                  <div class="font-weight-black">
                                    Med Visit Notification
                                  </div>
                                  <div>
                                    <v-checkbox
                                      v-model="notifications.medVisit.create"
                                      hide-details
                                      label="Create med visit"
                                    ></v-checkbox>
                                    <v-checkbox
                                      v-model="notifications.medVisit.update"
                                      hide-details
                                      label="Update med visit"
                                    ></v-checkbox>
                                    <v-checkbox
                                      v-model="notifications.medVisit.delete"
                                      hide-details
                                      label="Delete med visit"
                                    ></v-checkbox>
                                  </div>
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col>
                                  <div class="font-weight-black">
                                    Medication Notification
                                  </div>
                                  <div>
                                    <v-checkbox
                                      v-model="notifications.medication.create"
                                      hide-details
                                      label="Create Medication"
                                    ></v-checkbox>
                                    <v-checkbox
                                      v-model="notifications.medication.update"
                                      hide-details
                                      label="Update Medication"
                                    ></v-checkbox>
                                    <v-checkbox
                                      v-model="notifications.medication.delete"
                                      hide-details
                                      label="Delete Medication"
                                    ></v-checkbox>
                                  </div>
                                </v-col>
                              </v-row>
                            </v-card-text>
                            <v-card-text>
                              <v-row
                                align="center"
                                justify="end"
                                class="mx-2 my-2"
                              >
                                <v-card-actions>
                                  <v-btn
                                    color="primary"
                                    @click="saveNotifSettings()"
                                    >Update</v-btn
                                  >
                                </v-card-actions>
                              </v-row>
                            </v-card-text>
                          </v-tab-item>
                          <v-tab-item>
                            <v-card-text>
                              <v-row>
                                <v-col>
                                  <div class="font-weight-black">
                                    MAR Notification
                                  </div>
                                  <div>
                                    <v-checkbox
                                      v-model="notifications.mar.createEmail"
                                      hide-details
                                      label="Create MAR"
                                    ></v-checkbox>
                                    <v-checkbox
                                      v-model="notifications.mar.updateEmail"
                                      hide-details
                                      label="Update MAR"
                                    ></v-checkbox>
                                    <v-checkbox
                                      v-model="notifications.mar.deleteEmail"
                                      hide-details
                                      label="Delete MAR"
                                    ></v-checkbox>
                                  </div>
                                </v-col>
                                <v-col>
                                  <div class="font-weight-black">
                                    ADL Notification
                                  </div>
                                  <div>
                                    <v-checkbox
                                      v-model="notifications.adl.createEmail"
                                      hide-details
                                      label="Create ADL"
                                    ></v-checkbox>
                                    <v-checkbox
                                      v-model="notifications.adl.updateEmail"
                                      hide-details
                                      label="Update ADL"
                                    ></v-checkbox>
                                    <v-checkbox
                                      v-model="notifications.adl.deleteEmail"
                                      hide-details
                                      label="Delete ADL"
                                    ></v-checkbox>
                                  </div>
                                </v-col>
                                <v-col>
                                  <div class="font-weight-black">
                                    Med Visit Notification
                                  </div>
                                  <div>
                                    <v-checkbox
                                      v-model="notifications.medVisit.createEmail"
                                      hide-details
                                      label="Create med visit"
                                    ></v-checkbox>
                                    <v-checkbox
                                      v-model="notifications.medVisit.updateEmail"
                                      hide-details
                                      label="Update med visit"
                                    ></v-checkbox>
                                    <v-checkbox
                                      v-model="notifications.medVisit.deleteEmail"
                                      hide-details
                                      label="Delete med visit"
                                    ></v-checkbox>
                                  </div>
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col>
                                  <div class="font-weight-black">
                                    Medication Notification
                                  </div>
                                  <div>
                                    <v-checkbox
                                      v-model="notifications.medication.createEmail"
                                      hide-details
                                      label="Create Medication"
                                    ></v-checkbox>
                                    <v-checkbox
                                      v-model="notifications.medication.updateEmail"
                                      hide-details
                                      label="Update Medication"
                                    ></v-checkbox>
                                    <v-checkbox
                                      v-model="notifications.medication.deleteEmail"
                                      hide-details
                                      label="Delete Medication"
                                    ></v-checkbox>
                                  </div>
                                </v-col>
                              </v-row>
                            </v-card-text>
                            <v-card-text>
                              <v-row
                                align="center"
                                justify="end"
                                class="mx-2 my-2"
                              >
                                <v-card-actions>
                                  <v-btn
                                    color="primary"
                                    @click="saveNotifSettings()"
                                    >Update</v-btn
                                  >
                                </v-card-actions>
                              </v-row>
                            </v-card-text>
                          </v-tab-item>
                          <v-tab-item>
                            <v-card-text>
                              <v-row>
                                <v-col>
                                  <div class="font-weight-black">
                                    MAR Notification
                                  </div>
                                  <div>
                                    <v-checkbox
                                      v-model="notifications.mar.createText"
                                      hide-details
                                      label="Create MAR"
                                    ></v-checkbox>
                                    <v-checkbox
                                      v-model="notifications.mar.updateText"
                                      hide-details
                                      label="Update MAR"
                                    ></v-checkbox>
                                    <v-checkbox
                                      v-model="notifications.mar.deleteText"
                                      hide-details
                                      label="Delete MAR"
                                    ></v-checkbox>
                                  </div>
                                </v-col>
                                <v-col>
                                  <div class="font-weight-black">
                                    ADL Notification
                                  </div>
                                  <div>
                                    <v-checkbox
                                      v-model="notifications.adl.createText"
                                      hide-details
                                      label="Create ADL"
                                    ></v-checkbox>
                                    <v-checkbox
                                      v-model="notifications.adl.updateText"
                                      hide-details
                                      label="Update ADL"
                                    ></v-checkbox>
                                    <v-checkbox
                                      v-model="notifications.adl.deleteText"
                                      hide-details
                                      label="Delete ADL"
                                    ></v-checkbox>
                                  </div>
                                </v-col>
                                <v-col>
                                  <div class="font-weight-black">
                                    Med Visit Notification
                                  </div>
                                  <div>
                                    <v-checkbox
                                      v-model="notifications.medVisit.createText"
                                      hide-details
                                      label="Create med visit"
                                    ></v-checkbox>
                                    <v-checkbox
                                      v-model="notifications.medVisit.updateText"
                                      hide-details
                                      label="Update med visit"
                                    ></v-checkbox>
                                    <v-checkbox
                                      v-model="notifications.medVisit.deleteText"
                                      hide-details
                                      label="Delete med visit"
                                    ></v-checkbox>
                                  </div>
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col>
                                  <div class="font-weight-black">
                                    Medication Notification
                                  </div>
                                  <div>
                                    <v-checkbox
                                      v-model="notifications.medication.createText"
                                      hide-details
                                      label="Create Medication"
                                    ></v-checkbox>
                                    <v-checkbox
                                      v-model="notifications.medication.updateText"
                                      hide-details
                                      label="Update Medication"
                                    ></v-checkbox>
                                    <v-checkbox
                                      v-model="notifications.medication.deleteText"
                                      hide-details
                                      label="Delete Medication"
                                    ></v-checkbox>
                                  </div>
                                </v-col>
                              </v-row>
                            </v-card-text>
                            <v-card-text>
                              <v-row
                                align="center"
                                justify="end"
                                class="mx-2 my-2"
                              >
                                <v-card-actions>
                                  <v-btn
                                    color="primary"
                                    @click="saveNotifSettings()"
                                    >Update</v-btn
                                  >
                                </v-card-actions>
                              </v-row>
                            </v-card-text>
                          </v-tab-item>
                        </v-tabs>
                      </v-card>
                    </template>
                  </v-tab-item>
                  <!--END CLIENT NOTIFICATION-->
                </v-tabs>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
/* eslint-disable */
import axios from "axios";
import Foot from "../components/Footer";
import { mapGetters, mapActions, mapState } from "vuex";
import { setProfileTimezone } from "../../utils/timezone";
import SignaturePad from "@/components/SignaturePad";
import moment from 'moment';


const url = require("../client_config/config").url;
export default {
  components: {
    Foot,
    SignaturePad
  },
  data: () => ({
    birthMenu: false,
    anniversaryMenu: false,
    activePicker: null,
    birthDate: null,
    anniversaryDate: null,
    timezones: [],
    userTimezone: "",
    tzDialog: false,
    passdialog: false,
    seditInfo: false,
    chgimg: false,
    userID: "",
    msg: false,
    overlay: false,
    uploadImg: "",
    company: "",
    profileimg: "",
    text: "",
    Pass: "",
    RePass: "",
    selectedHourForShiftReminder : [],
    user: [],
    requiredField: [(v) => !!v || "This is required"],
    tab: null,
    tabs: ["User Notification", "Client Notification"],
      notifications: {
          employees: {
              create: false,
              createEmail: false,
              createText: false,
              delete: false,
              deleteEmail: false,
              deleteText: false,
              update: false,
              updateEmail: false,
              updateText: false,
          },
          maintenance: {
              create: false,
              createEmail: false,
              createText: false,
              delete: false,
              deleteEmail: false,
              deleteText: false,
              update: false,
              updateEmail: false,
              updateText: false,
          },
           timeoff: {
              create: false,
              createEmail: false,
              createText: false,
              delete: false,
              deleteEmail: false,
              deleteText: false,
              update: false,
              updateEmail: false,
              updateText: false,
          },
          incidents: {
              create: false,
              createEmail: false,
              createText: false,
              delete: false,
              deleteEmail: false,
              deleteText: false,
              update: false,
              updateEmail: false,
              updateText: false,
          },
          users: {
              create: false,
              createEmail: false,
              createText: false,
              delete: false,
              deleteEmail: false,
              deleteText: false,
              update: false,
              updateEmail: false,
              updateText: false,
          },
          shifts: {
              create: false,
              createEmail: false,
              createText: false,
              delete: false,
              deleteEmail: false,
              deleteText: false,
              update: false,
              updateEmail: false,
              updateText: false,
          },
          calendar: {
              create: false,
              createEmail: false,
              createText: false,
              delete: false,
              deleteEmail: false,
              deleteText: false,
              update: false,
              updateEmail: false,
              updateText: false,
          },
          client: {
              create: false,
              createEmail: false,
              createText: false,
              delete: false,
              deleteEmail: false,
              deleteText: false,
              update: false,
              updateEmail: false,
              updateText: false,
          },
          mar: {
              create: false,
              createEmail: false,
              createText: false,
              delete: false,
              deleteEmail: false,
              deleteText: false,
              update: false,
              updateEmail: false,
              updateText: false,
          },
          adl: {
              create: false,
              createEmail: false,
              createText: false,
              delete: false,
              deleteEmail: false,
              deleteText: false,
              update: false,
              updateEmail: false,
              updateText: false,
          },
          medVisit: {
              create: false,
              createEmail: false,
              createText: false,
              delete: false,
              deleteEmail: false,
              deleteText: false,
              update: false,
              updateEmail: false,
              updateText: false,
          },
          medication: {
              create: false,
              createEmail: false,
              createText: false,
              delete: false,
              deleteEmail: false,
              deleteText: false,
              update: false,
              updateEmail: false,
              updateText: false,
          },
          task: {
              create: false,
              createEmail: false,
              createText: false,
              delete: false,
              deleteEmail: false,
              deleteText: false,
              update: false,
              updateEmail: false,
              updateText: false,
          },
          dor: {
              create: false,
              delete: false,
              update: false,
          },
          rad: {
              create: false,
              delete: false,
              update: false,
          },
          certificationExpiration: {
              create: false,
              createEmail: false,
              createText: false,
              delete: false,
              deleteEmail: false,
              deleteText: false,
              update: false,
              updateEmail: false,
              updateText: false,
          },
          vehicleInspection: {
              update: false,
              updateEmail: false,
              updateText: false,
          },
        training: {
          create: false,
          createEmail: false,
          createText: false,
          delete: false,
          deleteEmail: false,
          deleteText: false,
          update: false,
          updateEmail: false,
          updateText: false,
        },
          text: false,
      },
      pushNotifications: {
        enabled: false,
        sound: true,
        vibration: true,
        preview: true,
        status: null
      },
    newName: "",
    newEmail: "",
    newPassword: "",
    newRePass: "",
    newRole: "",
    position: [
      "Admin",
      "House Manager",
      "Assistant Manager",
      "Direct Care Staff",
    ],
    status: ["Full-Time", "Part-Time"],
    newDate: "",
    newProgram: "",
    newPhoneNumber: "",
    newPhoneCarrier: "",
    newPhoneGateway: "",
    newAddress: "",
    newCity: "",
    newState: "",
    newZip: "",
    newPosition: "",
    newStatus: "",
    newSecurityQuestion: "",
    programs: [],
    states: ["Utah", "Nevada"],
    Role: localStorage.getItem('userRole'),
    isAdmin: false,
    userSignature: null,
    userSignatureImgSrc: null,
    userInitials: null,
    userInitialsImgSrc: null,
    showSignaturePad: false,
    showInitialsPad: false,
    signatureMode: 'signature', // or 'initials'
  }),

  computed: {
    ...mapGetters("timezones", [
      "getTimezones",
      "getUserTimezone",
      "getDefaultTz",
    ]),

    ...mapState("timezones", ["defaultTZ"]),

    timezone() {
      const data = {
        userTimezone: this.getUserTimezone,
        defaultTz: this.getDefaultTz,
      };
      return setProfileTimezone(data);
    },

    // Password validation message
    passwordMatchMessage() {
      if (this.Pass && this.RePass) {
        return this.Pass === this.RePass ? '' : 'Passwords do not match';
      }
      return '';
    },

    // Password strength properties
    passwordRequirements() {
      return this.Pass ? this.validatePasswordStrength(this.Pass) : {
        length: false,
        uppercase: false,
        lowercase: false,
        numbers: false,
        special: false
      };
    },

    passwordStrengthMessage() {
      return this.Pass ? this.getPasswordStrengthMessage(this.Pass) : '';
    },

    passwordStrengthColor() {
      return this.Pass ? this.getPasswordStrengthColor(this.Pass) : 'grey';
    },

    passwordStrengthScore() {
      return this.Pass ? this.getPasswordStrengthScore(this.Pass) : 0;
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    birthMenu (val) {
      val && setTimeout(() => (this.activePicker = 'YEAR'))
    },
    anniversaryMenu (val) {
      val && setTimeout(() => (this.activePicker = 'YEAR'))
    },
  },

  created() {
    this.fetchUser();
    this.userID = localStorage.getItem("userID");
    this.getUserInfo(this.userID);
    this.getUnits();
    if(localStorage.getItem('userRole') === "Administration" ||
    localStorage.getItem('userRole') === "Program Coordinator" ||
    localStorage.getItem('userRole') === "Compliance Manager" ||
    localStorage.getItem('userRole') === "Human Resources" ||
    localStorage.getItem('userRole') === "Client Services Manager"){
      this.isAdmin = true
    }
    // Initialize push notification settings
    this.initializePushNotifications();
  },

  props: {

    mode: {
      type: String,
      default: 'signature' // default mode is 'signature'
    }
  },

  methods: {
    ...mapActions("timezones", ["updateTimezone", "fetchUser"]),

    // Password comparison function
    checkPasswordMatch() {
      if (this.Pass && this.RePass) {
        return this.Pass === this.RePass;
      }
      return false;
    },

    // Password strength validation
    validatePasswordStrength(password) {
      const requirements = {
        length: password.length >= 8,
        uppercase: /[A-Z]/.test(password),
        lowercase: /[a-z]/.test(password),
        numbers: /[0-9]/.test(password),
        special: /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/.test(password)
      };
      
      return requirements;
    },

    // Get password strength score (0-5)
    getPasswordStrengthScore(password) {
      if (!password) return 0;
      
      const requirements = this.validatePasswordStrength(password);
      return Object.values(requirements).filter(Boolean).length;
    },

    // Get password strength message
    getPasswordStrengthMessage(password) {
      if (!password) return '';
      
      const score = this.getPasswordStrengthScore(password);
      
      if (score === 5) return 'Strong password';
      if (score === 4) return 'Good password';
      if (score === 3) return 'Fair password';
      if (score === 2) return 'Weak password';
      if (score === 1) return 'Very weak password';
      return 'Invalid password';
    },

    // Get password strength color
    getPasswordStrengthColor(password) {
      const score = this.getPasswordStrengthScore(password);
      
      if (score === 5) return 'success';
      if (score === 4) return 'info';
      if (score === 3) return 'warning';
      if (score <= 2) return 'error';
      return 'grey';
    },

    validate() {
      return this.$refs.form.validate();
    },

    save() {
      const { isEmpty, data } = this.$refs.signaturePad.saveSignature();
      if (this.mode === 'signature') {
        // Emit signature data
        this.$emit("signatureData", data);
      } else if (this.mode === 'initials') {
        // Emit initials data
        this.$emit("initialsData", data);
      }
      this.show = isEmpty;
    },

    clearSignature(){
        this.userSignature = null;
        this.userSignatureImgSrc = null;
    },

    clearInitials(){
        this.userInitials = null;
        this.userInitialsImgSrc = null;
    },

    openSignaturePad(mode) {
      this.signatureMode = mode;
      this.showSignaturePad = true;
    },

    openInitialsPad(mode) {
      this.signatureMode = mode;
      this.showInitialsPad = true;
    },

    handleSignatureData(data) {
      this.userSignature = data;
      this.userSignatureImgSrc = data; // Assuming `data` is the data URL of the signature image.
      this.showSignaturePad = false;
    },

    handleInitialsData(data) {
      this.userInitials = data;
      this.userInitialsImgSrc = data;
      this.showSignaturePad = false;
    },

    initialize() {},

    updateInfo() {
      if (this.validate()) {
        let req_body = {
          Name: this.newName,
          Email: this.newEmail,
          Date: this.newDate,
          BirthDate: this.birthDate,
          AnniversaryDate: this.anniversaryDate,
          Program: this.newProgram,
          PhoneNumber: this.newPhoneNumber,
          PhoneCarrier: this.newPhoneCarrier,
          Address: this.newAddress,
          SecurityQuestion: this.newSecurityQuestion,
          City: this.newCity,
          State: this.newState,
          Zip: this.newZip,
          Signature: this.userSignature,
          Initials: this.userInitials,
        };

        axios.put(`${url}/users/${this.userID}`, req_body).then((response) => {
          if (response.status === 400) {
            response.json().then(function(data) {
              this.msg = true;
              this.text = data.msg;
            });
          }

          this.getUserInfo(this.userID);
          this.text = "The account details have been updated successfully.";
          this.msg = true;
          this.close();
        });
      }
    },
    updatePassword() {
      if (this.validate()) {
        if (this.checkPasswordMatch()) {
          let req_body = {
            password: this.Pass,
          };

          axios.put(`${url}/users/${this.userID}/update-password`, req_body)
            .then((response) => {
              if (response.status === 400) {
                response.json().then(function(data) {
                  this.msg = true;
                  this.text = data.msg;
                });
              }
            });
          this.text = "The account password has been updated successfully.";
          this.msg = true;
          this.close();
        } else {
          this.text = "The passwords do not match, please try again.";
          this.msg = true;
        }
      }
    },
    getUserInfo: function(id) {
      axios.get(`${url}/users/${id}`).then((res) => {
        this.user = res.data.user;
        this.notifications = { ...res.data.user.Notifications };
        // this.getUserCompany(this.user.CompanyID);
        this.profileimg = this.user.Image;
        this.newPhoneGateway = this.user.PhoneGateway;
        this.newPhoneNumber = this.user.PhoneNumber;
        this.selectedHourForShiftReminder = this.user.HoursForShiftReminder;
      });
    },

    getUserCompany: function(id) {
      axios.get(`${url}/companies/${id}`).then((res) => {
        this.company = res.data.company.Name;
      });
    },


    close() {
      this.seditInfo = false;
      this.passdialog = false;
      this.chgimg = false;
    },
    chgImg() {
      this.chgimg = true;
    },
    editInfo() {
      this.seditInfo = true;
      this.newName = this.user.Name;
      this.newEmail = this.user.Email;
      this.birthDate = this.checkDate(this.user.BirthDate);
      this.anniversaryDate = this.user.AnniversaryDate;
      this.newDate = this.user.Date;
      this.newProgram = this.user.Program;
      this.newPhoneNumber = this.user.PhoneNumber;
      this.newPhoneCarrier = this.user.PhoneCarrier;
      this.newAddress = this.user.Address;
      this.newCity = this.user.City;
      this.newState = this.user.State;
      this.newZip = this.user.Zip;
      this.newStatus = this.user.status;
      this.userSignatureImgSrc = this.user.Signature;
      this.userInitialsImgSrc = this.user.Initials;
    },
    editPassword() {
      this.passdialog = true;
    },
    editTimezone() {
      this.tzDialog = true;
    },
    imgSelected(e) {
      this.uploadImg = e;
    },
    saveImg() {
      //console.log(this.uploadImg)
      const formData = new FormData();
      formData.append("profile-img", this.uploadImg);
      var ct = { headers: { "content-type": "multipart/form-data" } };
      axios
        .post(`${url}/users/imguploader/${this.userID}`, formData, ct)
        .then((res) => {
          //this.profileimg = '/uploads/'+res.data.file.filename;
          this.close();
          this.getUserInfo(this.userID);
          this.text =
            "The account profile picture has been updated successfully.";
          this.msg = true;
          if (res) {
            console.log();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    saveNotifSettings() {
      let req_body = {
        Notifications: { ...this.notifications },
        hourForShiftReminder : this.selectedHourForShiftReminder,
        pushNotifications: { ...this.pushNotifications }
      };

      console.log("NOTIFICATION" + req_body);

      axios
        .put(`${url}/users/${this.userID}/notification-settings`, req_body)
        .then((res) => {
          // this.close();
          if (res.status === 200) {
            this.text = res.data.msg;
            this.msg = true;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async updateTimezoneHandler(defaultTz = false) {
      const data = {
        _id: this.userID,
        Timezone: defaultTz ? this.defaultTZ : this.userTimezone
      };

      this.updateTimezone(data)
        .then((response) => {
          if (response.data.success) {
            this.msg = true;
            this.text = "The timezone has been updated successfully";
            this.tzDialog = false;
            this.fetchUser();
            return;
          }
        })
        .catch((error) => {
          console.log(error);
          this.msg = true;
          this.text = "something went wrong";
        });
    },

    textNotification(e) {
      this.$nextTick(() => {
        if (this.notifications.text === true) {
          if (this.newPhoneNumber === "" || this.newPhoneGateway === "") {
            this.msg = true;
            this.text =
              "Phone number and Phone carrier must not be empty. Please update your Phone Number and Phone Carrier";
            this.notifications.text = false;
          }
        }
      });
    },

    getUnits: function() {
      axios.get(`${url}/units`).then(async (res) => {
        this.programs = res.data.units;
      });
    },

      checkDate(date) {
          if (!moment(date, 'YYYY-MM-DD', true).isValid()) {
              return "";
          }
          return moment(date).format('YYYY-MM-DD');
      },

    // Push notification methods
    async initializePushNotifications() {
      try {
        // Check if user has existing push notification preferences
        if (this.user && this.user.pushNotifications) {
          this.pushNotifications = { ...this.user.pushNotifications };
        }
        
        // Check current notification permission status
        if ('Notification' in window) {
          if (Notification.permission === 'granted') {
            // Check if user is already subscribed
            const registration = await navigator.serviceWorker.getRegistration();
            if (registration) {
              const subscription = await registration.pushManager.getSubscription();
              if (subscription) {
                this.pushNotifications.enabled = true;
              }
            }
          }
        }
      } catch (error) {
        console.error('Error initializing push notifications:', error);
      }
    },

    async handlePushNotificationsToggle() {
      if (this.pushNotifications.enabled) {
        try {
          // Request notification permission
          const permission = await this.requestNotificationPermission();
          if (permission === 'granted') {
            // Subscribe to push notifications
            await this.subscribeToPushNotifications();
            this.pushNotifications.status = {
              type: 'success',
              message: 'Push notifications enabled successfully!'
            };
          } else {
            this.pushNotifications.enabled = false;
            this.pushNotifications.status = {
              type: 'error',
              message: 'Notification permission denied. Please enable notifications in your browser settings.'
            };
          }
        } catch (error) {
          this.pushNotifications.enabled = false;
          this.pushNotifications.status = {
            type: 'error',
            message: 'Failed to enable push notifications: ' + error.message
          };
        }
      } else {
        // Unsubscribe from push notifications
        await this.unsubscribeFromPushNotifications();
        this.pushNotifications.status = {
          type: 'info',
          message: 'Push notifications disabled.'
        };
      }
    },

    async requestNotificationPermission() {
      if (!('Notification' in window)) {
        throw new Error('This browser does not support notifications');
      }

      if (Notification.permission === 'granted') {
        return 'granted';
      }

      if (Notification.permission === 'denied') {
        throw new Error('Notification permission denied');
      }

      return await Notification.requestPermission();
    },

    async subscribeToPushNotifications() {
      try {
        // Check if service worker is supported
        if (!('serviceWorker' in navigator) || !('PushManager' in window)) {
          throw new Error('Push notifications are not supported in this browser');
        }

        // Register service worker
        const registration = await navigator.serviceWorker.register('/sw.js');
        console.log('Service Worker registered:', registration);

        // Subscribe to push notifications
        const subscription = await registration.pushManager.subscribe({
          userVisibleOnly: true,
          applicationServerKey: this.urlBase64ToUint8Array(this.getVapidPublicKey())
        });

        // Send subscription to server
        await this.sendSubscriptionToServer(subscription);

        console.log('Push notification subscription successful');
      } catch (error) {
        console.error('Error subscribing to push notifications:', error);
        throw error;
      }
    },

    async unsubscribeFromPushNotifications() {
      try {
        const registration = await navigator.serviceWorker.getRegistration();
        if (registration) {
          const subscription = await registration.pushManager.getSubscription();
          if (subscription) {
            await subscription.unsubscribe();
            await this.removeSubscriptionFromServer();
            console.log('Push notification unsubscription successful');
          }
        }
      } catch (error) {
        console.error('Error unsubscribing from push notifications:', error);
      }
    },

    async sendSubscriptionToServer(subscription) {
      try {
        const response = await fetch('/api/push-notifications/subscribe', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('token')}`
          },
          body: JSON.stringify({
            subscription,
            userId: this.userID
          })
        });

        if (!response.ok) {
          throw new Error('Failed to send subscription to server');
        }

        const result = await response.json();
        console.log('Subscription sent to server:', result);
      } catch (error) {
        console.error('Error sending subscription to server:', error);
        throw error;
      }
    },

    async removeSubscriptionFromServer() {
      try {
        const response = await fetch('/api/push-notifications/unsubscribe', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('token')}`
          },
          body: JSON.stringify({
            userId: this.userID
          })
        });

        if (!response.ok) {
          throw new Error('Failed to remove subscription from server');
        }

        console.log('Subscription removed from server');
      } catch (error) {
        console.error('Error removing subscription from server:', error);
      }
    },

    async testPushNotification() {
      try {
        this.pushNotifications.status = {
          type: 'info',
          message: 'Sending test notification...'
        };

        const response = await fetch('/api/push-notifications/send/' + this.userID, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('token')}`
          },
          body: JSON.stringify({
            title: 'Test Notification',
            body: 'This is a test push notification from ClimateRX!',
            icon: '/icon-192x192.png',
            data: {
              type: 'test',
              timestamp: new Date().toISOString()
            }
          })
        });

        if (response.ok) {
          this.pushNotifications.status = {
            type: 'success',
            message: 'Test notification sent successfully! Check your notifications.'
          };
        } else {
          throw new Error('Failed to send test notification');
        }
      } catch (error) {
        this.pushNotifications.status = {
          type: 'error',
          message: 'Failed to send test notification: ' + error.message
        };
      }
    },

    async getVapidPublicKey() {
      try {
        const response = await fetch('/api/push-notifications/vapid-public-key');
        if (response.ok) {
          const data = await response.json();
          return data.publicKey;
        }
      } catch (error) {
        console.error('Error fetching VAPID public key:', error);
      }
      // Fallback to placeholder if server is not available
      return 'BK26l2zgGYbGHYc0ratu...';
    },

    urlBase64ToUint8Array(base64String) {
      const padding = '='.repeat((4 - base64String.length % 4) % 4);
      const base64 = (base64String + padding)
        .replace(/-/g, '+')
        .replace(/_/g, '/');

      const rawData = window.atob(base64);
      const outputArray = new Uint8Array(rawData.length);

      for (let i = 0; i < rawData.length; ++i) {
        outputArray[i] = rawData.charCodeAt(i);
      }
      return outputArray;
    }

  },
};
</script>
<style scoped>
div.my-tabs [role="tab"] {
  justify-content: flex-start;
}
div.my-tabs .v-icon {
  margin-right: 10px;
}
</style>